<template>
  <ViewLoader v-if="loading"/>

  <section class="checkout-section-wrapper" v-else>
    <CheckoutSuccess v-if="orderId" :order-id="orderId"/>

    <template v-else-if="cartDigitalItems.length > 0">
      <ModalVoucher :checkinId="voucherCheckinId" @voucher-redeemed="$store.dispatch('cart/getCart')"/>
      <ViewHeader class="d-none d-lg-block">
        <template #title>{{ $t('pages.checkout.page_title') }}</template>
        <template #intro>{{ $t('pages.checkout.page_subtitle') }}</template>
      </ViewHeader>

      <div class="container view-body view-body--padded">
        <div class="row pb-lg-8">
          <template>
            <section class="col-lg-8">
              <DigitalItems v-if="cartDigitalItems && cartDigitalItems.length > 0"/>
            </section>

            <section class="col-lg-4">
              <CheckoutSummary @pay-clicked="checkout($event)"/>

              <ModalCheckoutStripe modalId="modal-stripe-card"
                                   :modal-title="$t('pages.checkout.modal_payment_withcard_modal_title')"
                                   :payment-method="payModes.CARD"
                                   :payment-methods-stripe="['card']"
                                   @order-success="orderId = $event"/>

              <ModalCheckoutStripe modalId="modal-stripe-ideal"
                                   :modal-title="$t('pages.checkout.modal_payment_withideal_modal_title')"
                                   :payment-method="payModes.IDEAL"
                                   :payment-methods-stripe="['ideal']"
                                   :return-url="`/checkout/complete`"
                                   @order-success="orderId = $event"/>

              <ModalCheckoutStripe modalId="modal-stripe-p24"
                                   :modal-title="$t('pages.checkout.modal_payment_withp24_modal_title')"
                                   :payment-method="payModes.P24"
                                   :payment-methods-stripe="['p24']"
                                   :return-url="`/checkout/complete`"
                                   @order-success="orderId = $event"/>


              <CheckoutMercadoPago modalId="modal-stripe-mercadopago"
                                   :payment-settings="paymentSettingsMercadoPago"
                                   @order-success="orderId = $event"/>

              <ModalPayWithBankTransfer modalId="modal-bank-transfer"
                                           @order-success="orderId = $event"
                                           ref="modal-bank-transfer"/>

            </section>

          </template>
        </div>
      </div>
    </template>


    <CheckoutEmptyCart v-else/>

  </section>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import ViewHeader from '@/components/ViewHeader'
import CheckoutEmptyCart from "@/components/CheckoutEmptyCart"
import CheckoutSummary from "@/domain/checkout/CheckoutSummary.vue"
import ModalPayWithBankTransfer from "@/domain/checkout/modals/ModalPayWithBankTransfer.vue"
import ViewLoader from "@/components/ViewLoader"
import ModalVoucher from "@/components/ModalVoucher"
import CheckoutSuccess from "@/views/CheckoutSuccess"
import CheckoutMercadoPago from "@/domain/checkout/modals/CheckoutMercadoPago.vue";
import DigitalItems from "@/domain/cart/DigitalItems.vue";
import ModalCheckoutStripe from "@/domain/checkout/modals/ModalCheckoutStripe.vue";
import {payModes} from "@/domain/checkout/constants";

export default {
  components: {
    ModalCheckoutStripe,
    DigitalItems,
    CheckoutMercadoPago,
    ViewLoader,
    ViewHeader,
    ModalVoucher,
    CheckoutEmptyCart,
    CheckoutSummary,
    ModalPayWithBankTransfer,
    CheckoutSuccess,
  },

  data() {
    return {
      loading: true,
      isMobileOpen: false,
      orderId: null,
      voucherCheckinId: null,
    }
  },

  async mounted() {
    await this.fetchDigitalItems({includeMedia: true})
    await this.fetchPayments()
    await this.fetchTotalCartItems()
    this.loading = false
  },

  computed: {
    ...mapGetters('cartDigitalItems', [
      'cartDigitalItems',
      'paymentMethods',
      'paymentSettings',
      'totalCartItems'
    ]),
    paymentSettingsMercadoPago() {
      return this.paymentSettings[payModes.MERCADO_PAGO]
    },
    payModes() {
      return payModes
    },
  },

  methods: {
    ...mapMutations('cartDigitalItems', ['resetCart']),
    ...mapActions('cartDigitalItems', [
      'fetchDigitalItems',
      'fetchPayments',
      'fetchTotalCartItems',
      'createOrder',
      'deleteCart'
    ]),
    async checkout(paymentMethodSelected) {

      if (paymentMethodSelected === null) {
        this.loading = true

        const order = await this.createOrder()
        this.loading = false
        this.orderId = order.id
        await this.deleteCart()

      } else if (paymentMethodSelected === payModes.CARD) {
        this.$bvModal.show('modal-stripe-card')
      } else if (paymentMethodSelected === payModes.IDEAL) {
        this.$bvModal.show('modal-stripe-ideal')
      } else if (paymentMethodSelected === payModes.MERCADO_PAGO) {
        this.$bvModal.show('modal-stripe-mercadopago')
      } else if (paymentMethodSelected === payModes.P24) {
        this.$bvModal.show('modal-stripe-p24')
      } else if (paymentMethodSelected === payModes.BANK_TRANSFER) {
        this.$refs['modal-bank-transfer'].showAndPay()
      }
    },

    openModalVoucher(checkinId) {
      this.voucherCheckinId = checkinId
      this.$bvModal.show('modal-voucher')
      this.$store.dispatch('cart/getCart')
          .then(() => {
          })
    }
  }
}
</script>
